// extracted by mini-css-extract-plugin
module.exports = {"activity":"activityWrap_activity___njMV","wrap":"activityWrap_wrap__TR48d"};